import { factory } from '../factory';
import { udrsAssetV1Adapter } from './asset-v1';
import { udrsAssetV2Adapter, udrsStoreV2Adapter } from './asset-v2';
import { udrsEngineV2Adapter } from './engine-v2';

/**
 * Note: `UDRsPolyAsset` is set in the Redux store.
 */

/**
 * Converts `redaction-media-data` asset `boundingPoly` data to `UDRsPolyAsset`.
 */
export const udrsAssetToStoreAdapter = factory(
  udrsAssetV1Adapter(),
  udrsAssetV2Adapter()
);

/**
 * Converts `UDRsPolyAsset` to `boundingPoly` in `redaction-media-data`.
 */
export const udrsStoreToAssetAdapter = factory(udrsStoreV2Adapter());

/**
 * Converts OT engine results into `UDRsPolyAsset`.
 */
export const udrsEngineToStoreAdapter = factory(udrsEngineV2Adapter());
